export const emptyPassport = () => ({
  number: '',
  issueDate: '',
  placeOfIssue: '',
});

const toDateValue = (value) => {
  if (!value) return '';
  return String(value).split('T')[0];
};

const asPassport = (item) => {
  if (item && typeof item === 'object' && !Array.isArray(item)) {
    return {
      number: String(item.number || item.passport_no || '').trim(),
      issueDate: toDateValue(item.issueDate || item.issue_date || ''),
      placeOfIssue: String(item.placeOfIssue || item.place_of_issue || '').trim(),
    };
  }
  return {
    number: String(item || '').trim(),
    issueDate: '',
    placeOfIssue: '',
  };
};

export const parsePassports = (passportNo, issueDate, placeOfIssue) => {
  let list = [];
  if (Array.isArray(passportNo)) {
    list = passportNo.map(asPassport);
  } else if (passportNo && typeof passportNo === 'object') {
    list = [asPassport(passportNo)];
  } else if (passportNo) {
    const str = String(passportNo).trim();
    try {
      const parsed = JSON.parse(str);
      if (Array.isArray(parsed)) list = parsed.map(asPassport);
      else if (parsed && typeof parsed === 'object') list = [asPassport(parsed)];
    } catch {
      if (str.includes(',')) {
        list = str.split(',').map(asPassport);
      } else {
        list = [asPassport(str)];
      }
    }
  }

  if (!list.length) list = [emptyPassport()];

  if (list[0] && !list[0].issueDate && issueDate) {
    list[0] = { ...list[0], issueDate: toDateValue(issueDate) };
  }
  if (list[0] && !list[0].placeOfIssue && placeOfIssue) {
    list[0] = { ...list[0], placeOfIssue: String(placeOfIssue).trim() };
  }

  return list;
};

export const serializePassports = (list) => {
  const cleaned = (list || [])
    .map((p) => ({
      number: String(p?.number || '').trim(),
      issueDate: toDateValue(p?.issueDate),
      placeOfIssue: String(p?.placeOfIssue || '').trim(),
    }))
    .filter((p) => p.number || p.issueDate || p.placeOfIssue);

  if (!cleaned.length) return [];
  return cleaned;
};
